import React, { useEffect, useState } from "react";
import Index from "../../../Index";
import ComingSoon from "../comingSoon/ComingSoon";
import PagesIndex from "../../../PagesIndex";
import MembershipCouponModal from "./MembershipCouponModal";

const membershipDurationConstant = {
  30: "1 Month",
  90: "3 Month",
  365: "1 Year",
};

function Membership() {
  const [membershipItem, setMembershipItem] = useState([]);
  const [activePlan, setActivePlan] = useState(null);
  const [open, setOpen] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = React.useState("");
  const [selectedMembership, setSelectedMembership] = useState(null);
  const [btnLoading, setbtnLoading] = useState(false);
  const navigate = PagesIndex.useNavigate();
  const { userToken, isLoggedIn } = PagesIndex.useSelector(
    (state) => state.UserReducer
  );
  const dispatch = PagesIndex.useDispatch();
  const [toggle, setToggle] = useState(false);

  console.log(isLoggedIn, "qwqwqwqwq");
  const signInOpen = () => {
    setToggle(true);
  };
  const signInClose = () => setToggle(false);

  const handleClose = () => {
    setOpen(false);
    setSelectedMembership(null);
  };
  const handleOpen = (data) => {
    setOpen(true);
    setSelectedMembership(data);
  };
  const getMembershipDetails = () => {
    dispatch(PagesIndex.showLoader());
    PagesIndex.apiGetHandler(PagesIndex.Api.GET_MEMBERSHIP_LIST)
      .then((res) => {
        dispatch(PagesIndex.hideLoader());

        if (res?.status === 200) {
          // Sort the membership items by price in ascending order (lowest to highest)
          let sortedItems = res?.data.sort((a, b) => a.price - b.price);

          sortedItems = sortedItems.filter((item) => item.isPublished === true);

          setMembershipItem(sortedItems);
        }
      })
      .catch((error) => {
        dispatch(PagesIndex.hideLoader());
        PagesIndex.toast.error("Failed to load membership details");
      });
  };

  const getMembershipList = () => {
    dispatch(PagesIndex.showLoader());
    PagesIndex.apiGetHandler(
      PagesIndex.Api.GET_MEMBERSHIP_TRANSACTION_LIST,
      "",
      userToken
    )
      .then((res) => {
        dispatch(PagesIndex.hideLoader());

        if (res?.status === 200) {
          // Filter to get the active plan
          const activePlan = res?.data.find((data) => data?.isActive === true);
          setActivePlan(activePlan?.subscriptionId);
          console.log(res?.data, "res?.data ");
        }
      })
      .catch((error) => {
        dispatch(PagesIndex.hideLoader());
        PagesIndex.toast.error("Failed to load active membership");
      });
  };

  useEffect(() => {
    getMembershipDetails();
    getMembershipList();
  }, [userToken]);

  const displayRazorpay = (item) => {
    // console.log(item, "item in displayRazorpay", { selectedMembership });
    setbtnLoading(true);
    const urlencoded = new URLSearchParams();
    urlencoded.append("subscriptionId", item?.membershipId);
    if (appliedCoupon) {
      urlencoded.append("couponCode", item?.couponCode || "");
    
    }
    PagesIndex.apiPostHandler(
      PagesIndex.Api.BUY_MEMBERSHIP,
      urlencoded,
      userToken
    )
      .then((res) => {
        PagesIndex.toast.error(res?.message, { toastId: "membershipError" });
        const paymentDiv = document.getElementById("payment_html");
        paymentDiv.innerHTML = res;
        let arr = paymentDiv.getElementsByTagName("script");

        for (let elem of arr) {
          eval(elem.innerHTML);
        }
      })

      .catch((error) => {
        dispatch(PagesIndex.hideLoader());
        PagesIndex.toast.error("Something went wrong");
      })
      .finally(() => {
        setbtnLoading(false);
      });
  };

  return (
    <Index.Box className="main-membership">
      <Index.Box className="cus-container">
        <Index.Box className="membership-header">
          <Index.Typography
            variant="h1"
            component="h1"
            className="membership-header-title"
          >
            Membership
          </Index.Typography>
          <Index.Typography
            variant="p"
            component="p"
            className="membership-header-subtitle"
          >
            Join membership by choosing your perfect option below
          </Index.Typography>
        </Index.Box>
        {membershipItem.length > 0 ? (
          <Index.Box className="membership-body">
            <Index.Box className="membership-item-box">
              {membershipItem?.map((item, key) => (
                <Index.Box key={key} className="membership-item">
                  <Index.Typography className="membership-title">
                    {item.title}
                  </Index.Typography>
                  <Index.Typography className="small-member-text">
                    {item.title === "platinum"
                      ? "Enjoy exclusive benefits like free tickets and VIP access"
                      : item.title === "gold"
                      ? "Unlock special discounts and perks for a premium movie experience"
                      : "Get started with basic savings and rewards"}
                  </Index.Typography>
                  {/* Show Active Plan text if this is the active plan  */}
                  {/* {activePlan && activePlan.title === item.title && (
                    <Index.Typography className="small-member-text active-plan">
                      Active Plan
                    </Index.Typography>
                  )} */}

                  <Index.Box className="button-inner-memberlist">
                    <Index.Box className="membership-price line-cross-prices">
                      <Index.Typography className="membership-price-inner">
                        Rs.
                        {item?.isDiscounted ? (
                          <>
                            <span className="line-add-prices">
                              {item?.price}{" "}
                            </span>{" "}
                            <span>
                              {" "}
                              / <span>{item?.discountedPrice}</span>
                            </span>{" "}
                          </>
                        ) : (
                          item?.price
                        )}
                        <br />
                        <span className="yearly-title">
                          {" "}
                          {item?.membershipDuration && (
                            <Index.Typography className="">
                              {membershipDurationConstant?.[
                                item?.membershipDuration
                              ] || ""}
                            </Index.Typography>
                          )}
                        </span>
                      </Index.Typography>
                    </Index.Box>

                    <Index.Box className="list-center-member">
                      <Index.Box className="membership-content-box">
                        <Index.Typography
                          className={
                            item?.discountOfFAndBUpTo === ""
                              ? "membership-content disable"
                              : "membership-content active"
                          }
                        >
                          {item?.discountOfFAndBUpTo === "" ? (
                            <Index.ClearIcon />
                          ) : (
                            <Index.CheckIcon />
                          )}
                          {/* <Index.CheckIcon /> */}
                          <Index.Box className="membership-content-box">
                            {item?.discountOfFAndBUpTo === ""
                              ? "No Discount on F&B"
                              : `Upto ${item?.discountOfFAndBUpTo}% Discount on F&B: Save on
                           delicious snacks and drinks`}
                          </Index.Box>
                        </Index.Typography>
                      </Index.Box>
                      <Index.Box className="membership-content-box">
                        <Index.Typography
                          className={
                            item?.discountOnTicketUpTo === ""
                              ? "membership-content disable"
                              : "membership-content active"
                          }
                        >
                          {item?.discountOnTicketUpTo === "" ? (
                            <Index.ClearIcon />
                          ) : (
                            <Index.CheckIcon />
                          )}

                          <Index.Box className="membership-content-box">
                            {item?.discountOnTicketUpTo === ""
                              ? "No Discount on Tickets"
                              : `Upto ${item?.discountOnTicketUpTo}% Discount on Tickets: Get
                            more movies for your money`}
                          </Index.Box>
                        </Index.Typography>
                      </Index.Box>
                      {/* <Index.Box className="membership-content-box">
                        <Index.Typography
                          className={
                            item?.freeTicket === ""
                              ? "membership-content disable"
                              : "membership-content active"
                          }
                        >
                          {item?.freeTicket === "" ? (
                            <Index.ClearIcon />
                          ) : (
                            <Index.CheckIcon />
                          )}
                          <Index.Box className="membership-content-box">
                            {item?.freeTicket === ""
                              ? "No Free Tickets"
                              : ` ${item?.freeTicket} Free Tickets: Enjoy complimentary
                            movie outings.`}
                          </Index.Box>
                        </Index.Typography>
                      </Index.Box> */}
                      <Index.Box className="membership-content-box">
                        <Index.Typography
                          className={
                            item?.coins === ""
                              ? "membership-content disable"
                              : "membership-content active"
                          }
                        >
                          {item?.coins === "" ? (
                            <Index.ClearIcon />
                          ) : (
                            <Index.CheckIcon />
                          )}
                          <Index.Box className="membership-content-box">
                            {item?.coins === ""
                              ? "No Coins to Earn Rewards"
                              : `Upto ${item?.coins}% Coins: Earn rewards redeemable for
                            tickets, concessions, and more`}
                          </Index.Box>
                        </Index.Typography>
                      </Index.Box>
                      <Index.Box className="membership-content-box">
                        <Index.Typography
                          className={
                            item?.welcomeGift === "Yes"
                              ? "membership-content active"
                              : "membership-content disable"
                          }
                        >
                          {item?.welcomeGift === "Yes" ? (
                            <Index.CheckIcon />
                          ) : (
                            <Index.ClearIcon />
                          )}

                          {item?.welcomeGift === "Yes" ? (
                            <Index.Box className="membership-content-box">
                              Welcome Gift: Receive a special surprise when you
                              join.
                            </Index.Box>
                          ) : (
                            <Index.Box className="membership-content-box">
                              No Welcome Gift
                            </Index.Box>
                          )}
                        </Index.Typography>
                      </Index.Box>
                      {/* Show Buy Now button only if there is no active plan or if this plan is different */}
                      {!activePlan || activePlan.title !== item.title ? (
                        <Index.Box className="membership-btn-box">
                          <PagesIndex.Button
                            secondary
                            className="membership-btn"
                            onClick={() => {
                              if (isLoggedIn) {
                                handleOpen(item);
                                // displayRazorpay(item);
                              } else {
                                signInOpen();
                              }
                            }}
                          >
                            Buy Now
                          </PagesIndex.Button>
                        </Index.Box>
                      ) : (
                        <>
                          <Index.Box className="membership-btn-box">
                            <PagesIndex.Button
                              secondary
                              className="membership-btn"
                              disabled
                            >
                              <Index.Typography className="small-member-text active-plan">
                                Active Plan
                              </Index.Typography>
                            </PagesIndex.Button>
                          </Index.Box>
                          {item?.membershipDuration && (
                            <Index.Typography className="membership-buration-text">
                              {membershipDurationConstant?.[
                                item?.membershipDuration
                              ] || ""}
                            </Index.Typography>
                          )}
                        </>
                      )}
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              ))}
            </Index.Box>
          </Index.Box>
        ) : (
          <ComingSoon />
        )}

        <Index.Box className="membership-term-box">
          <Index.Typography
            onClick={() => {
              navigate("/membership-terms-condition");
            }}
            className="terms-condition-title"
          >
            Terms & Conditions
          </Index.Typography>
        </Index.Box>
        {/* <ComingSoon />)  */}
      </Index.Box>
      <Index.Modal
        open={toggle}
        onClose={signInClose}
        aria-labelledby="signin-modal-title"
        aria-describedby="signin-modal-description"
        className="signin-modal"
      >
        <PagesIndex.Login signInClose={signInClose} />
      </Index.Modal>
    
      <MembershipCouponModal
        open={open}
        handleClose={handleClose}
        selectedMembership={selectedMembership}
        displayRazorpay={displayRazorpay}
        btnLoading={btnLoading}
        appliedCoupon={appliedCoupon}
        setAppliedCoupon={setAppliedCoupon}
        setbtnLoading={setbtnLoading}
      />
    </Index.Box>
  );
}

export default Membership;
